/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MailboxForwardDTO,
  MailboxItemChannel,
  MailboxItemDTO,
  MailboxItemDirection,
  MailboxItemOrigin,
  MailboxPageDTO,
  MailboxReplyDTO,
  MailboxSendDTO,
  MailboxThreadDTO,
  MailboxUpdateLinksDTO,
  ProblemDetails,
} from '../models/index';
import {
    MailboxForwardDTOFromJSON,
    MailboxForwardDTOToJSON,
    MailboxItemChannelFromJSON,
    MailboxItemChannelToJSON,
    MailboxItemDTOFromJSON,
    MailboxItemDTOToJSON,
    MailboxItemDirectionFromJSON,
    MailboxItemDirectionToJSON,
    MailboxItemOriginFromJSON,
    MailboxItemOriginToJSON,
    MailboxPageDTOFromJSON,
    MailboxPageDTOToJSON,
    MailboxReplyDTOFromJSON,
    MailboxReplyDTOToJSON,
    MailboxSendDTOFromJSON,
    MailboxSendDTOToJSON,
    MailboxThreadDTOFromJSON,
    MailboxThreadDTOToJSON,
    MailboxUpdateLinksDTOFromJSON,
    MailboxUpdateLinksDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface MailboxGetRequest {
    origin?: MailboxItemOrigin;
    direction?: MailboxItemDirection;
    channel?: MailboxItemChannel;
    profileId?: number;
    todoId?: number;
    jobApplicationId?: number;
    skip?: number;
    take?: number;
}

export interface MailboxIdForwardPostRequest {
    id: string;
    mailboxForwardDTO?: MailboxForwardDTO;
}

export interface MailboxIdGetRequest {
    id: string;
}

export interface MailboxIdLinksPutRequest {
    id: string;
    mailboxUpdateLinksDTO?: MailboxUpdateLinksDTO;
}

export interface MailboxIdReadPatchRequest {
    id: string;
}

export interface MailboxIdReplyPostRequest {
    id: string;
    mailboxReplyDTO?: MailboxReplyDTO;
}

export interface MailboxSendPostRequest {
    mailboxSendDTO?: MailboxSendDTO;
}

export interface MailboxUnreadCountGetRequest {
    origin?: MailboxItemOrigin;
}

/**
 * 
 */
export class MailboxApi extends runtime.BaseAPI {

    /**
     */
    async mailboxGetRaw(requestParameters: MailboxGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxPageDTO>> {
        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['channel'] != null) {
            queryParameters['channel'] = requestParameters['channel'];
        }

        if (requestParameters['profileId'] != null) {
            queryParameters['profileId'] = requestParameters['profileId'];
        }

        if (requestParameters['todoId'] != null) {
            queryParameters['todoId'] = requestParameters['todoId'];
        }

        if (requestParameters['jobApplicationId'] != null) {
            queryParameters['jobApplicationId'] = requestParameters['jobApplicationId'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/Mailbox`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxPageDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxGet(requestParameters: MailboxGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxPageDTO> {
        const response = await this.mailboxGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxIdForwardPostRaw(requestParameters: MailboxIdForwardPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxItemDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxIdForwardPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/Mailbox/{id}/forward`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxForwardDTOToJSON(requestParameters['mailboxForwardDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxItemDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxIdForwardPost(requestParameters: MailboxIdForwardPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxItemDTO> {
        const response = await this.mailboxIdForwardPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxIdGetRaw(requestParameters: MailboxIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxThreadDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/Mailbox/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxThreadDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxIdGet(requestParameters: MailboxIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxThreadDTO> {
        const response = await this.mailboxIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxIdLinksPutRaw(requestParameters: MailboxIdLinksPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxItemDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxIdLinksPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/Mailbox/{id}/links`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxUpdateLinksDTOToJSON(requestParameters['mailboxUpdateLinksDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxItemDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxIdLinksPut(requestParameters: MailboxIdLinksPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxItemDTO> {
        const response = await this.mailboxIdLinksPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxIdReadPatchRaw(requestParameters: MailboxIdReadPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxIdReadPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/Mailbox/{id}/read`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailboxIdReadPatch(requestParameters: MailboxIdReadPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailboxIdReadPatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async mailboxIdReplyPostRaw(requestParameters: MailboxIdReplyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxItemDTO>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mailboxIdReplyPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/Mailbox/{id}/reply`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxReplyDTOToJSON(requestParameters['mailboxReplyDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxItemDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxIdReplyPost(requestParameters: MailboxIdReplyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxItemDTO> {
        const response = await this.mailboxIdReplyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxSendPostRaw(requestParameters: MailboxSendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxItemDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/Mailbox/send`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxSendDTOToJSON(requestParameters['mailboxSendDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxItemDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxSendPost(requestParameters: MailboxSendPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxItemDTO> {
        const response = await this.mailboxSendPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxUnreadCountGetRaw(requestParameters: MailboxUnreadCountGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['origin'] != null) {
            queryParameters['origin'] = requestParameters['origin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/Mailbox/unread-count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async mailboxUnreadCountGet(requestParameters: MailboxUnreadCountGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.mailboxUnreadCountGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
